export function isElectron() {
  return !!window.isElectron;
}
